var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.32 49.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #f26c2e;\n      }\n\n      .cls-4 {\n        fill: #245fa6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "head_foot",
    "data-name": "head foot"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.72,32.47h-5.58l-1.14,2.62h-1.25l4.6-10.25h1.22l4.58,10.25h-1.27l-1.16-2.62Zm-.47-1.08l-2.33-5.27-2.3,5.27h4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.67,25.88c-2.31,0-4.17,1.8-4.17,4.07s1.86,4.09,4.17,4.09c1.13,0,2.23-.47,3.03-1.23l.72,.78c-1.01,.95-2.39,1.55-3.81,1.55-2.96,0-5.3-2.28-5.3-5.18s2.37-5.14,5.35-5.14c1.41,0,2.77,.57,3.75,1.49l-.7,.85c-.79-.79-1.9-1.27-3.03-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.42,25.88c-2.31,0-4.17,1.8-4.17,4.07s1.86,4.09,4.17,4.09c1.13,0,2.23-.47,3.03-1.23l.72,.78c-1.01,.95-2.39,1.55-3.81,1.55-2.96,0-5.3-2.28-5.3-5.18s2.37-5.14,5.35-5.14c1.41,0,2.77,.57,3.75,1.49l-.7,.85c-.79-.79-1.9-1.27-3.03-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.99,24.84v1.08h-5.78v3.44h5.17v1.07h-5.17v3.57h5.98v1.08h-7.15v-10.25h6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.5,24.84v9.17h4.5v1.08h-5.67v-10.25h1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.61,24.84v1.08h-5.78v3.44h5.17v1.07h-5.17v3.57h5.98v1.08h-7.15v-10.25h6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.65,35.09l-2.15-3.28c-.21,.01-.42,.03-.66,.03h-2.72v3.25h-1.17v-10.25h3.9c2.56,0,4.04,1.26,4.04,3.44,0,1.68-.84,2.84-2.31,3.31l2.42,3.5h-1.33Zm-2.81-4.34c1.86,0,2.91-.84,2.91-2.45s-1.05-2.39-2.91-2.39h-2.72v4.83h2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.76,32.47h-5.58l-1.14,2.62h-1.24l4.6-10.25h1.22l4.58,10.25h-1.27l-1.16-2.62Zm-.47-1.08l-2.33-5.27-2.3,5.27h4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.06,24.84v1.08h-3.35v9.17h-1.17v-9.17h-3.34v-1.08h7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.63,29.97c0,2.89-2.37,5.17-5.36,5.17s-5.37-2.28-5.37-5.17,2.37-5.16,5.37-5.16,5.36,2.27,5.36,5.16Zm-9.55,0c0,2.27,1.9,4.1,4.19,4.1s4.16-1.83,4.16-4.1-1.87-4.07-4.16-4.07-4.19,1.8-4.19,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.23,35.09l-2.15-3.28c-.21,.01-.42,.03-.66,.03h-2.72v3.25h-1.17v-10.25h3.9c2.56,0,4.04,1.26,4.04,3.44,0,1.68-.84,2.84-2.31,3.31l2.42,3.5h-1.33Zm-2.81-4.34c1.86,0,2.91-.84,2.91-2.45s-1.05-2.39-2.91-2.39h-2.72v4.83h2.72Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.14,
    y: 40.87,
    width: 37.04,
    height: 8.18
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.13 0 91.81 8.18 91.81 16.26 97.13 10.94 97.13 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.58,9.9l-1.67,2.57c-.9,1.39-1.38,3-1.38,4.66v2.59l3.05-3.05v-6.77Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.58 0 103.9 8.18 103.9 16.26 98.58 10.94 98.58 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.13,9.9l1.67,2.57c.9,1.39,1.38,3,1.38,4.66v2.59l-3.05-3.05v-6.77Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.13 13.91 95.9 15.63 97.13 22.79 97.13 13.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.77 13.91 99.99 15.63 98.77 22.79 98.77 13.91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.03,1.56v.96H6.51v15.4h-.98V2.52H0v-.96H12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.78,1.56v7.68h11.07V1.56h.98V17.92h-.98v-7.72h-11.07v7.72h-.98V1.56h.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.27,13.26h-9.57l-2.11,4.66h-1.08L47.93,1.56h1.05l7.49,16.36h-1.08l-2.13-4.66Zm-.44-.98l-4.38-9.6-4.33,9.6h8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.14,1.56V17.92h-.98V1.56h.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.98,1.56v15.4h7.28v.96h-8.26V1.56h.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.68,1.56l10.93,14.86V1.56h.96V17.92h-1.15l-10.91-14.86v14.86h-.98V1.56h1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.32,9.75c0,4.54-3.75,8.17-8.43,8.17h-6.48V1.56h6.51c4.66,0,8.4,3.6,8.4,8.19Zm-1.01,0c0-4.03-3.3-7.23-7.42-7.23h-5.5v14.44h5.52c4.1,0,7.4-3.21,7.4-7.21Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.7,43.64v.52h-.84v2.22h-.62v-2.22h-.83v-.52h2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.51,43.64v.51h-1.47v.6h1.32v.51h-1.32v.61h1.51v.51h-2.13v-2.74h2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.71,44.16c-.47,0-.83,.36-.83,.84s.36,.85,.83,.85c.25,0,.52-.13,.71-.32l.36,.4c-.29,.3-.71,.49-1.11,.49-.82,0-1.44-.61-1.44-1.4s.63-1.39,1.46-1.39c.4,0,.81,.18,1.08,.45l-.36,.44c-.19-.22-.46-.36-.71-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.16,43.64v1.14h1.24v-1.14h.62v2.74h-.62v-1.08h-1.24v1.08h-.62v-2.74h.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.97,44.14c-.21,0-.35,.07-.35,.22,0,.51,1.46,.22,1.46,1.21,0,.54-.47,.83-1.07,.83-.45,0-.9-.17-1.21-.43l.25-.51c.28,.25,.68,.41,.97,.41,.25,0,.41-.09,.41-.26,0-.52-1.46-.22-1.46-1.19,0-.5,.43-.81,1.06-.81,.38,0,.77,.12,1.04,.3l-.24,.51c-.29-.17-.63-.28-.85-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.7,45.85h-1.27l-.22,.53h-.64l1.19-2.74h.64l1.17,2.74h-.66l-.22-.53Zm-.2-.5l-.43-1.07-.44,1.07h.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.38,45.87c.37,0,.61-.24,.61-.63v-1.59h.62v1.59c0,.72-.47,1.18-1.23,1.18s-1.25-.45-1.25-1.18v-1.59h.62v1.59c0,.4,.26,.63,.63,.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.82,44.16c-.47,0-.83,.36-.83,.84s.36,.85,.83,.85c.25,0,.52-.13,.71-.32l.36,.4c-.29,.3-.71,.49-1.11,.49-.82,0-1.44-.61-1.44-1.4s.63-1.39,1.46-1.39c.4,0,.81,.18,1.08,.45l-.36,.44c-.19-.22-.46-.36-.71-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.75,43.64v.51h-1.47v.6h1.32v.51h-1.32v.61h1.51v.51h-2.13v-2.74h2.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "64.05 44.85 64.05 46.1 61.27 47.71 60.18 47.08 64.05 44.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "64.05 42.89 62.96 42.27 61.57 43.06 61.57 44.32 64.05 42.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "62.67 44.05 61.58 44.67 62.66 45.3 63.74 44.67 62.67 44.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "61.27 44.49 61.27 44.49 61.27 44.49 61.27 43.24 60.18 43.86 60.18 43.86 58.48 44.85 58.48 46.09 60.18 45.12 60.18 46.73 61.27 46.1 61.27 44.49"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.14,
    y: 40.9,
    width: 37.04,
    height: 8.18
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3d250cbaba136bdcca2b18e66b265c28.svg";
export { ForwardRef as ReactComponent };